<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <v-alert :value="true"  v-if="error != null" type="error" class="mb-5">{{ error.message }}</v-alert>

        <v-layout justify-center column pb-5>
          <v-form ref="form" v-model="valid"  @submit="login">

            <v-text-field outline v-model="username" :rules="usernameRules" label="Email address" required></v-text-field>

            <v-text-field outline v-model="code" :rules="codeRules" label="Verification code" required></v-text-field>

            <v-text-field outline v-model="pass" :rules="passRules" label="New password" type="password" required></v-text-field>
            <v-layout row>
              <v-flex xs12 pb-0>
                <p class="password-notice">A valid password must contain one upper case letter, one lower case letter, a number and a special character (e.g. ^ $ * . ! @ # % &amp;) and also must be at least 8 characters in length.</p>
              </v-flex>
            </v-layout>

            <v-layout row align-center mx-1>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid" color="success">Set password</button>
            </v-layout>
            

          </v-form>
        </v-layout>

        <v-layout row>
          <v-flex xs12 pb-0>
            <p>Not got a verification code or need a new one? <router-link to="forgot-password">Click here</router-link> to get one.</p>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ResetPasswordForm',
  data () {
    
    return {
      valid: true,
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        v => /.*[a-z].*/.test(v) || 'Password must contain at least one lower case letter',
        v => /.*[A-Z].*/.test(v) || 'Password must contain at least one upper case letter',
        v => /\d/.test(v) || 'Password must contain at least one number',
        v => /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || 'Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      codeRules: [
        v => !!v || 'Verification code is required',
        v => /\S/.test(v) || 'Verification code is must be the correct format'
      ],
      username: '',
      code: '',
      pass: '',
      error: null,
      loading: false
    }
  },
  mounted (){
    
    // check for query string params to populate
    var search = location.search.substring(1);
    var parameters = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
    //alert(parameters)
    console.log(parameters)
    if(parameters.code.length === 6){
      this.code = parameters.code
    }
    if(parameters.email){
      this.username = decodeURIComponent(parameters.email).replace(' ','+')
    }

  },
  methods: {
    login(e) {
        e.preventDefault()
        this.loading = true
        var email = this.username
        var code = this.code
        var password = this.pass

        this.$confirmPassword(email, code, password).subscribe((data) => {
            console.log('reset password success success');
            this.$router.push("/login-post-verify");
        }, 
        (err)=> {
            
          this.error = err;
          if(this.error.message == 'Invalid code provided, please request a code again.'){
            this.error.message = 'Please ensure that you enter the correct verification code and the correct email address that you registered with.'
          }
            
        });

    }
  }
}
</script>

<style scoped>
</style>